"use client";
import BackBtn from "./components/BackBtn";
import EmblaCarousel from "../design1/components/DynamicSlider";
import { planImage } from "../design1/SalePage1";
import { utilities } from "../design1/PropertyPage1";
import { propertyDetails2 } from "../design3/Pages/Sale3";
import { KeyValueDisplay } from "./Rent2";
import { usePathname } from "next/navigation";
import { useSearchParams } from "next/navigation";
import { PropertyUtilities2 } from "../../constants/utilitiesIcons";
import { Accordion } from "./Rent2";
// import {  } from "../design1/components/Listing";
// import {  } from "./ContactUs2";
import { ParentCard } from "../design1/PropertyPage1";
import ImageGrid from "./components/ImageGrid";
import { mockProperties } from "../../constants/mockProperties";
import { Form } from "../design1/components/ContactMandate";
import React from "react";
import Example from "../design1/components/Map";
import { MemberType, PropertyType } from "src/types";
import Link from "next/link";
import { members } from "../design1/components";
import CardGrid from "../../CardGrid";
import { CardVariant2 } from "./components/CardVariant2";
import { useParams } from "next/navigation";
import { findPropertyById } from "../../constants/mockProperties";
import { PropertyCard } from "./Rent2";
import { generateSliderImages } from "../design3/components/PropertyCarousel2";
import Button from "../../ui/Button";
import { ShowMoreText } from "../design1/About1";
import Image from "next/image";
import { generateSlugWithId } from "src/app/serverUtils";
import { capitalizeWords } from "../../utils";
import { VerifiedBadge } from "../../Icon";

const Sale2 = () => {
  const images = generateSliderImages(mockProperties.forRent[0].images);
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const property = findPropertyById(toNum)!;
  if (!property) {
    return <div>No property Available</div>;
  }
  const isOutRight = !property.beforePrice;
  return (
    <section>
      <div className="wrapper pb-10 pt-8">
        <BackBtn dark />
        <PropertyCard
          quote={property.quote}
          title={property.title}
          price={property.price}
          propertyId="6454545"
          address={property.address}
          beforePrice={property?.beforePrice}
          discount={property.discount}
          quotePrice={property.quotePrice}
          priceType={property.priceType}
        />
        <div className="second">
          <ImageGrid
            images={[
              ...images,
              {
                url: "https://www.youtube.com/watch?v=m3E72ZJ54_k",
                type: "video",
              },
            ]}
          />
        </div>

        <div className="grid-container mt-8">
          <div className="first flex flex-col gap-4">
            {" "}
            <ParentCard variant header="Property Brief">
              <ShowMoreText maxLength={300} text={mockDesc} />
            </ParentCard>
            <ParentCard variant header="Facilities">
              <PropertyUtilities2 selectedItems={utilities} />
            </ParentCard>
            {isOutRight && (
              <ParentCard header="Property Information">
                <KeyValueDisplay data={propertyDetails} />
              </ParentCard>
            )}
            {!isOutRight && (
              <ParentCard header="Property Information">
                <KeyValueDisplay data={propertyDetails2} />
              </ParentCard>
            )}
            {isOutRight && (
              <ParentCard variant header="Price and Other Charges">
                <KeyValueDisplay money data={priceDetails} />
              </ParentCard>
            )}
            {!isOutRight && (
              <ParentCard variant header="Terms & Conditions">
                <Accordion
                  data={{
                    questions: [
                      {
                        question: "Refund Policy",
                        answer: "You can request a refund within 7 days.",
                      },
                      {
                        question: "Property Facility",
                        answer: "Facilities include WiFi, Pool, and Gym.",
                      },
                      {
                        question: "Other Rules",
                        answer: "No smoking inside the premises.",
                      },
                    ],
                  }}
                />
              </ParentCard>
            )}
            {!isOutRight && (
              <ParentCard variant header="First Deposit">
                <KeyValueDisplay money data={firstDeposit} />
              </ParentCard>
            )}
            {!isOutRight && (
              <ParentCard variant header="Monthly Spreading">
                <KeyValueDisplay money data={monthlySpreading} />
              </ParentCard>
            )}
            {!isOutRight && (
              <ParentCard variant header="Other Charges">
                <KeyValueDisplay money data={otherCharges} />
              </ParentCard>
            )}
            {isOutRight && (
              <ParentCard header="Document">
                <p className="mb-4">C of O. Record Copy Survey, Agreement</p>
                <div className="carousel w-auto">
                  <EmblaCarousel variant slides={planImage} />
                </div>
              </ParentCard>
            )}
            {isOutRight && (
              <ParentCard header="Buiding Plan">
                <div className="carousel w-auto">
                  <EmblaCarousel variant slides={planImage} />
                </div>
              </ParentCard>
            )}
            <ParentCard variant header="Location">
              <Example coordinates={[6.4913408, 3.391488]} />
            </ParentCard>
          </div>

          <SideItem2 properties={mockProperties.forRent} member={members[0]} />
          {/* <div className="second flex flex-col gap-8 ">
            <div className="first bg-white  rounded-xl">
              <h5 className="p-3 font-semibold text-secondary-main">
                Staff Contact
              </h5>
              <StaffContact {...members[0]} />
              <div className="p-3">
                <Form variant />
              </div>
            </div>
            <div className="second p-3 bg-white  rounded-xl">
              <div className="alal  flex items-center justify-between">
                <h5 className=" font-semibold text-secondary-main">
                  Staff Listing
                </h5>
                <Link
                  className="text-themeColor hover:underline"
                  href="/properties"
                >
                  See More
                </Link>
              </div>
              <CardGrid className="divide-y divide-y-themeColor" maxColumns={1}>
                {mockProperties.forRent.map((item, index) => {
                  return (
                    <div key={index} className="pt-4">
                      <CardVariant2 {...item} />
                    </div>
                  );
                })}
              </CardGrid>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};
export default Sale2;

export const SideItem2: React.FC<{
  member?: MemberType;
  properties?: PropertyType[];
}> = ({ member, properties }) => {
  return (
    <div className="second max-h-[1200px] sticky top-[95px] scrollbar-hide overflow-auto flex flex-col gap-8 ">
      {member?.name ? (
        <div className="first bg-white  rounded-xl">
          <h5 className="p-3 font-semibold text-secondary-main">
            Contact Mandate
          </h5>
          <StaffContact {...member} />
          <div className="p-3">
            <Form email={member.email} variant />
          </div>
        </div>
      ) : (
        <div>No member available</div>
      )}

      {properties && properties.length > 0 ? (
        <div className="second p-3 bg-white  rounded-xl">
          <div className="alal  flex items-center justify-between">
            <h5 className=" font-semibold text-secondary-main">
              Mandate Listing
            </h5>
            <Button variant="new" href="/properties">
              See More
            </Button>
          </div>
          <CardGrid className="divide-y divide-y-themeColor" maxColumns={1}>
            {properties.map((item, index) => {
              return (
                <div key={index} className="pt-4">
                  <CardVariant2 {...item} />
                </div>
              );
            })}
          </CardGrid>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

const propertyDetails: Record<string, string | number> = {
  "Property Title": "Obolongo Estate",
  Category: "Residential",
  Unit: "Unit 3 Bedroom, 1 Unit Self Contained With Penthouse",
  Document: "C of O. Record Copy Survey, Agreement",
  "Source/Owner": "Ibrahim Matthew",
  "Total Area": "4300sqm",
  Offer: 20,
  "Total Views": 20,
  Bookmarks: 20,
  "Added Date": "20/02/2025",
  "Last Updated": "20/02/2025",
};
// const initialPaymentDetails: Record<string, number> = {
//   "Inspection Fee": 3000000,
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Refundable Caution Fee": 3000000,
//   "Non-Refundable Legal Fee": 3000000,
//   "Non-Refundable Agency Fee": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

// const renewalTenantDetails: Record<string, number> = {
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

const StaffContact: React.FC<MemberType> = ({
  name,
  role,
  phone,
  image,
  email,
  is_verified,
  id,
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const fullUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${pathname}?${searchParams.toString()}`
      : "";
  const cleanPhone = phone.replace(/\D/g, "");
  const generatedPaths = generateSlugWithId(id, name);
  return (
    <div className="flex p-6 border-b flex-col items-center gap-2">
      <Image
        height={96}
        width={96}
        src={image || "no image"}
        className="image block size-[6rem] rounded-full"
        alt={name}
      />
      <h4 className="text-secondary-main hover:underline  font-semibold">
        <Link
          className="hover:underline items-center flex gap-2"
          href={`/staff/${generatedPaths}`}
        >
          {" "}
          {capitalizeWords(name)}{" "}
          <VerifiedBadge verified={is_verified as boolean} />
        </Link>
      </h4>
      <h6>{role}</h6>

      {phone && (
        <Link
          href={`tel:${phone}`}
          className="flex hover:underline gap-2 items-center"
        >
          <CallIcon /> {phone || "No phone available"}
        </Link>
      )}

      {email && (
        <Link
          href={`mailto:${email}`}
          className="flex gap-2 hover:underline items-center"
        >
          <MessageIcon /> {email}
        </Link>
      )}

      {phone && (
        <Link
          target="_blank"
          href={`https://wa.me/${cleanPhone}?text=Hello, I will like to enquire about this property on your website. ${fullUrl}`}
          className="flex gap-2 hover:underline items-center"
        >
          <WhatsAppIcon /> Message on WhatsApp
        </Link>
      )}
    </div>
  );
};

const CallIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5871 2.34385C16.5934 2.55525 18.4675 3.44512 19.8995 4.8663C21.3314 6.28747 22.2353 8.15481 22.4618 10.1595M14.5871 6.28121C15.5552 6.47211 16.4436 6.9496 17.1369 7.65171C17.8303 8.35382 18.2965 9.24813 18.4752 10.2186M22.4126 17.0302V19.9832C22.4137 20.2574 22.3576 20.5287 22.2477 20.7799C22.1379 21.0311 21.9768 21.2566 21.7748 21.4419C21.5728 21.6272 21.3343 21.7683 21.0746 21.8561C20.8149 21.944 20.5398 21.9766 20.2667 21.9519C17.2378 21.6224 14.3284 20.5874 11.7719 18.93C9.39356 17.4187 7.37714 15.4023 5.86585 13.0239C4.20263 10.4558 3.16739 7.53221 2.84393 4.48971C2.81933 4.2175 2.85168 3.94316 2.93892 3.68415C3.02615 3.42513 3.16637 3.18712 3.35063 2.98526C3.5349 2.78341 3.75917 2.62213 4.00918 2.5117C4.25919 2.40127 4.52945 2.3441 4.80276 2.34385H7.75578C8.23349 2.33914 8.69661 2.50831 9.05882 2.81981C9.42102 3.1313 9.6576 3.56388 9.72446 4.03691C9.84877 4.98201 10.0799 5.90994 10.4135 6.80291C10.5459 7.15522 10.5746 7.53812 10.4961 7.90623C10.4176 8.27434 10.2352 8.61223 9.97055 8.87986L8.72044 10.13C10.1217 12.5943 12.1621 14.6348 14.6265 16.036L15.8766 14.7859C16.1442 14.5213 16.4821 14.3389 16.8502 14.2604C17.2183 14.1819 17.6012 14.2105 17.9535 14.343C18.8465 14.6765 19.7744 14.9077 20.7195 15.032C21.1977 15.0994 21.6344 15.3403 21.9466 15.7087C22.2587 16.0771 22.4246 16.5475 22.4126 17.0302Z"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const MessageIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.94922 7.86028C2.94922 7.33816 3.15663 6.83741 3.52583 6.46821C3.89503 6.09902 4.39577 5.8916 4.9179 5.8916H18.6987C19.2208 5.8916 19.7215 6.09902 20.0907 6.46821C20.4599 6.83741 20.6673 7.33816 20.6673 7.86028V17.7037C20.6673 18.2258 20.4599 18.7265 20.0907 19.0957C19.7215 19.4649 19.2208 19.6724 18.6987 19.6724H4.9179C4.39577 19.6724 3.89503 19.4649 3.52583 19.0957C3.15663 18.7265 2.94922 18.2258 2.94922 17.7037V7.86028Z"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.94922 7.85645L11.8083 13.7625L20.6673 7.85645"
        stroke="#2F364B"
        stroke-width="1.47651"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const firstDeposit: Record<string, string | number> = {
  "6 Months Plan": 3000000,
  "12 Months Plan": 3000000,
  "24 Months Plan": 3000000,
  "48 Months Plan": 3000000,
};

const monthlySpreading: Record<string, string | number> = {
  "6 Months Plan": 3000000,
  "12 Months Plan": 3000000,
  "24 Months Plan": 3000000,
  "48 Months Plan": 3000000,
};

const otherCharges: Record<string, string | number> = {
  Documents: 3000000,
  "Survey Fee": 3000000,
  "Development Fee": 3000000,
  "Other Fee": 3000000,
};

const priceDetails: Record<string, number> = {
  "Property Price": 3000000,
  "Agency Fee": 3000000,
  "Inspection Fee": 3000000,
  "Other Fee": 3000000,
};

export const mockDesc = `<p>This stunning newly built 5-bedroom detached duplex offers modern living at its finest.</p>

<p>Spacious and beautifully designed, the property boasts 5 en-suite bedrooms, each thoughtfully crafted to provide comfort and privacy.</p>

<p>The fully equipped kitchen features top-quality finishes, including premium countertops, modern cabinetry, and state-of-the-art appliances, making it a dream for cooking enthusiasts.</p>

<p>The expansive living area is perfect for both relaxation and entertaining guests, with an open-concept design that enhances the sense of space and luxury.</p>

<p>Designed with convenience in mind, the home includes state-of-the-art amenities, ensuring a seamless blend of functionality and sophistication.</p>

<p>With ample parking space, homeowners can enjoy the ease of multiple vehicle accommodations.</p>

<p>A private garden offers a serene escape, ideal for outdoor relaxation, family gatherings, or even a touch of landscaping creativity.</p>

<p>Located in a prime residential area, this home provides easy access to essential services, top-rated schools, and vibrant shopping centers, making daily life effortlessly convenient.</p>

<p>Perfect for families seeking a harmonious blend of luxury, privacy, and accessibility, this exceptional duplex redefines upscale living.</p>
`;

const WhatsAppIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 12.379 1.28 13.693 1.784 14.888C2.063 15.548 2.202 15.878 2.22 16.128C2.237 16.378 2.163 16.652 2.016 17.201L1 21L4.799 19.984C5.348 19.837 5.622 19.764 5.872 19.78C6.122 19.798 6.452 19.937 7.112 20.216C8.34266 20.7343 9.66465 21.0009 11 21Z"
        stroke="#2f364b"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.58817 11.377L8.45917 10.296C8.82617 9.84 9.27917 9.416 9.31617 8.808C9.32417 8.655 9.21617 7.967 9.00117 6.59C8.91617 6.049 8.41017 6 7.97317 6C7.40317 6 7.11817 6 6.83517 6.13C6.47717 6.293 6.11017 6.752 6.02917 7.137C5.96517 7.442 6.01317 7.652 6.10817 8.072C6.51017 9.855 7.45517 11.616 8.91917 13.081C10.3842 14.545 12.1452 15.49 13.9292 15.892C14.3492 15.987 14.5582 16.035 14.8632 15.971C15.2482 15.891 15.7072 15.523 15.8712 15.165C16.0002 14.882 16.0002 14.597 16.0002 14.027C16.0002 13.589 15.9512 13.084 15.4102 12.999C14.0332 12.783 13.3452 12.676 13.1922 12.684C12.5852 12.72 12.1602 13.174 11.7042 13.541L10.6232 14.411"
        stroke="#2f364b"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
